$(document).on('click', '.mrk-addon-dropdown-item', function () {
    $(this)
    .closest('.mrk-frame-cart-addon-inner')
    .find('.mrk-cart-frame-add')
    .trigger('click');
});

 
(function () {
  function syncUpsellToProgressBar() {
    requestAnimationFrame(() => {
      const upsellSource = document.querySelector('.mrk-upsell-wrapper');
      const progressBarTarget = document.querySelector('.wd-collection-progress-bar');
 
      if (!upsellSource) return; // upsell block not present on this page
      if (!progressBarTarget) return; // progress bar not present
 
      // Replace the inner content of the progress bar with the upsell HTML
      progressBarTarget.innerHTML = upsellSource.innerHTML;
    });
  }
 
  // Fires in the `finally` block of updateQuantity — always runs after fetch
  document.addEventListener('cart:updated', syncUpsellToProgressBar);
 
  // Also run once on page load so the initial state is in sync
  document.addEventListener('DOMContentLoaded', syncUpsellToProgressBar);
})();
 

// document.addEventListener('DOMContentLoaded', function () {
//   const isTouchDevice = () => window.matchMedia('(hover: none) and (pointer: coarse)').matches;

//   function initPopup(wrapperSelector, iconSelector, popupSelector) {
//     document.querySelectorAll(wrapperSelector).forEach(function (wrapper) {
//       const icon = wrapper.querySelector(iconSelector);
//       const popup = wrapper.querySelector(popupSelector);

//       if (!icon || !popup) return;

//       if (!isTouchDevice()) {
//         let hideTimeout;

//         function showPopup() {
//           clearTimeout(hideTimeout);
//           popup.style.display = 'block';
//           popup.style.opacity = '1';
//           popup.style.visibility = 'visible';
//         }

//         function hidePopup() {
//           hideTimeout = setTimeout(function () {
//             popup.style.display = 'none';
//             popup.style.opacity = '0';
//             popup.style.visibility = 'hidden';
//           }, 100);
//         }

//         icon.addEventListener('mouseenter', showPopup);
//         icon.addEventListener('mouseleave', hidePopup);
//         popup.addEventListener('mouseenter', showPopup);
//         popup.addEventListener('mouseleave', hidePopup);

//       } else {
//         icon.addEventListener('click', function (e) {
//           e.stopPropagation();
//           const isVisible = popup.style.display === 'block';

//           // Close all popups first
//           document.querySelectorAll('.wd-subtotal-popup-wrapper, .wd-total-saving-popup-wrapper').forEach(function (p) {
//             p.style.display = 'none';
//             p.style.opacity = '0';
//             p.style.visibility = 'hidden';
//           });

//           if (!isVisible) {
//             popup.style.display = 'block';
//             popup.style.opacity = '1';
//             popup.style.visibility = 'visible';
//           }
//         });
//       }
//     });
//   }

//   // Init both popups
//   initPopup('.wd-cart-subtotal-wrapper', '.mrk-popup-icon', '.wd-subtotal-popup-wrapper');
//   initPopup('.mrk-saving-wrapper', '.mrk-popup-icon', '.wd-total-saving-popup-wrapper');

//   // Close on outside tap (mobile only)
//   document.addEventListener('click', function () {
//     if (!isTouchDevice()) return;
//     document.querySelectorAll('.wd-subtotal-popup-wrapper, .wd-total-saving-popup-wrapper').forEach(function (p) {
//       p.style.display = 'none';
//       p.style.opacity = '0';
//       p.style.visibility = 'hidden';
//     });
//   });
// });


// Shopify Forms app fixes. The full fix set is scoped to the trade-page popup
// form (#wd-trade-request-items); every other Forms embed store-wide gets ONLY
// the dropdown-under-field re-anchor (stock list height, no other changes).
// 1) Floating labels: the app measures label height once on mount; a form that
//    mounts inside a closed <dialog> measures 0 and every label gets an
//    off-center inline `top`. The CSS below re-centers state-independently
//    (textareas use the app's hardcoded 46px reference height, so 23px).
// 2) Select dropdowns: the app opens the option list upward whenever the field
//    sits in the lower half of the form; re-anchor it below the toggle so it
//    behaves like a normal dropdown, and lift the ~160px height cap to ~6 items.
// Depending on the app version/flow, the form renders either inside the open
// shadow root of a <shopify-forms-embed> or directly in the light DOM. Every
// fix is applied both ways: the stylesheet goes into any shadow root AND an
// id-scoped copy into document.head; element tweaks query both trees. The
// section gets data-wd-forms-fix="on" as inspectable proof the patch ran.
(function () {
  var SCOPE_ID = 'wd-trade-request-items';
  // Re-anchor the option list under the field, and unclip the app's own
  // wrappers (its inline embed wrapper and form container both have
  // overflow:hidden, which chops a downward list at the form's bottom edge —
  // the reason the app opens lists upward in the first place).
  var DROPDOWN_RULE =
    "[class*='_showUpwards_']{bottom:auto !important;top:100% !important;margin-bottom:0 !important;margin-top:4px !important;}" +
    "section[class*='_inline_']{overflow:visible !important;}" +
    "section[class*='_inline_'] [class*='_formContainer_']{overflow:visible !important;}";
  var FIX_RULES = [
    "label[id^='label-']{top:50% !important;translate:0 -50%;}",
    "div:has(> textarea) > label[id^='label-']{top:23px !important;}",
    DROPDOWN_RULE,
    "[class*='_dropdownContainer_'],[class*='_optionList_']{max-height:272px !important;}",
    // Project details: static label above the field (styled like the select's
    // "What do you need?" label) with the placeholder inside. Must come after
    // the generic label rules above so its overrides win on equal specificity.
    "div:has(> textarea) > label[for='custom#project_details']{position:static !important;order:-1;top:auto !important;translate:none !important;transform:none !important;font:var(--forms-body-font);line-height:20px;color:var(--body-text-color);padding-bottom:10px;}",
    "textarea[name='custom#project_details']{padding:var(--form-field-padding) !important;}",
    // The app's ::before bar only shields text from the floating label, which
    // no longer sits inside the box — left on, it paints over the new label.
    "div:has(> textarea[name='custom#project_details'])::before{display:none !important;}",
    "textarea::placeholder{color:var(--form-placeholder-color);}"
  ];
  var PROJECT_DETAILS_PLACEHOLDER =
    'Sizes, quantities, budget, deadline, and any pieces you already have in mind.';
  var patchedRoots = new WeakSet();
  var dropdownRoots = new WeakSet();

  function injectCss(root, css) {
    try {
      var sheet = new CSSStyleSheet();
      sheet.replaceSync(css);
      root.adoptedStyleSheets.push(sheet);
    } catch (error) {
      var style = document.createElement('style');
      style.textContent = css;
      root.appendChild(style);
    }
  }

  // Placeholder (React leaves unmanaged attributes alone, so it sticks) and
  // error spacing: inline margins beat any stylesheet, and the pull-up is
  // measured from the parent's real computed gap. Re-run by an observer since
  // errors only mount after a failed submit.
  function fixElements(tree) {
    var textarea = tree.querySelector("textarea[name='custom#project_details']");
    if (textarea && !textarea.placeholder) textarea.placeholder = PROJECT_DETAILS_PLACEHOLDER;
    tree.querySelectorAll('output[role="alert"]').forEach(function (err) {
      if (err.dataset.wdSpaced) return;
      err.dataset.wdSpaced = '1';
      var gap = parseFloat(getComputedStyle(err.parentElement).rowGap) || 12;
      err.style.setProperty('margin-top', 3 - gap + 'px', 'important');
      err.style.setProperty('margin-bottom', '12px', 'important');
    });
  }

  function watchTree(tree) {
    if (patchedRoots.has(tree)) return;
    patchedRoots.add(tree);
    fixElements(tree);
    new MutationObserver(function () {
      fixElements(tree);
    }).observe(tree, { childList: true, subtree: true });
  }

  function patchSection(scope) {
    scope.setAttribute('data-wd-forms-fix', 'on');

    // Light-DOM rendering: one id-scoped stylesheet in the document head.
    if (!document.getElementById('wd-forms-fix-style')) {
      var lightStyle = document.createElement('style');
      lightStyle.id = 'wd-forms-fix-style';
      lightStyle.textContent = FIX_RULES.map(function (rule) {
        return '#' + SCOPE_ID + ' ' + rule;
      }).join('');
      document.head.appendChild(lightStyle);
    }
    watchTree(scope);

    // Shadow-root rendering: inject the rules into each embed's root.
    scope.querySelectorAll('shopify-forms-embed').forEach(function (embed) {
      var root = embed.shadowRoot;
      if (!root || patchedRoots.has(root)) return;
      injectCss(root, FIX_RULES.join(''));
      watchTree(root);
    });
  }

  // Other forms store-wide: dropdown under the field only. The section raise
  // keeps a downward list from being covered by the next section (sections'
  // content wrappers all sit at z-index 1, so the later sibling wins ties);
  // dialog-hosted embeds are excluded — they render in the top layer, and
  // raising their host section would cover a raised sibling again.
  function patchOtherForm(host) {
    host.setAttribute('data-wd-dropdown-fix', 'on');
    if (!document.getElementById('wd-forms-dropdown-style')) {
      var st = document.createElement('style');
      st.id = 'wd-forms-dropdown-style';
      st.textContent =
        DROPDOWN_RULE +
        "#trade-sign-up-form [class*='_gridItemContent_']{padding-bottom:80px !important;}" +
        '.custom-section-content:has(shopify-forms-embed):not(:has(dialog shopify-forms-embed)){z-index:var(--layer-raised,2);}' +
        '.custom-section-content:has([data-form-root]):not(:has(dialog [data-form-root])){z-index:var(--layer-raised,2);}';
      document.head.appendChild(st);
    }
    var root = host.shadowRoot;
    if (root && !dropdownRoots.has(root)) {
      dropdownRoots.add(root);
      injectCss(root, DROPDOWN_RULE);
    }
  }

  // Trade sign-up form: the form ends flush with its section, leaving no room
  // for the open list, so its content area gets permanent bottom padding from
  // page load. The form hydrates after the page loads (inside the embed's
  // shadow root, or in the light DOM), so observers wait for it to appear,
  // apply the inline padding once, and disconnect.
  (function padTradeForm() {
    var section = document.getElementById('trade-sign-up-form');
    if (!section) return;
    var sectionObs = null;
    var shadowObs = null;
    var tryApply = function () {
      var host = section.querySelector('shopify-forms-embed');
      var roots = [section];
      if (host && host.shadowRoot) roots.push(host.shadowRoot);
      for (var i = 0; i < roots.length; i++) {
        var content = roots[i].querySelector("[class*='_gridItemContent_']");
        if (content) {
          content.style.setProperty('padding-bottom', '80px', 'important');
          if (sectionObs) sectionObs.disconnect();
          if (shadowObs) shadowObs.disconnect();
          return true;
        }
      }
      return false;
    };
    var check = function () {
      if (tryApply()) return;
      var host = section.querySelector('shopify-forms-embed');
      if (host && host.shadowRoot && !shadowObs) {
        shadowObs = new MutationObserver(tryApply);
        shadowObs.observe(host.shadowRoot, { childList: true, subtree: true });
      }
    };
    sectionObs = new MutationObserver(check);
    sectionObs.observe(section, { childList: true, subtree: true });
    check();
  })();

  function onFormsInteraction(event) {
    if (!(event.target instanceof Element)) return;
    var scope = event.target.closest('#' + SCOPE_ID);
    if (scope) {
      patchSection(scope);
      return;
    }
    var host = event.target.closest('shopify-forms-embed, [data-form-root]');
    if (host) patchOtherForm(host);
  }

  document.addEventListener('click', onFormsInteraction);
  document.addEventListener('focusin', onFormsInteraction);
})();
/* ---------------------------------------------------------------------------------------------
   Visible-viewport size, for bottom-anchored fixed UI.

   `position: fixed` is measured against the LAYOUT viewport. In Chrome and Safari that matches
   what the shopper can see, so `bottom: 0` sits on the bottom edge of the screen. Inside an app's
   own browser (Instagram, Facebook, TikTok — all WKWebView) the two disagree: the layout viewport
   keeps its full height while the visible area is shorter, so

     • the sticky Add to cart bar is drawn part-way UP the screen, and appears to jump back into
       place when the browser's own toolbars come and go, and
     • the quick-add modal, which is anchored to the bottom, hangs off the bottom of the screen —
       only its top part shows and the strip below it is the page.

   These two properties describe the box the shopper can actually see:

     --wd-vv-bottom   how far the visible bottom edge sits ABOVE the layout viewport's bottom
     --wd-vv-height   the visible height

   They are published ONLY while the two viewports actually disagree. Everywhere they agree — every
   desktop browser, Chrome and Safari on a phone — nothing is set at all and each rule falls back
   to the value it had before, so this cannot change how those browsers render.
   --------------------------------------------------------------------------------------------- */
(function () {
  var vv = window.visualViewport;
  if (!vv) return; // no API (older browsers): leave the plain `bottom: 0` behaviour alone
  var root = document.documentElement;
  var layoutH = root.clientHeight;
  var last = -1;

  function sync() {
    // Read the cached layout height: it only changes on a resize, and reading clientHeight on
    // every scroll frame would force a layout.
    var gap = Math.round(layoutH - (vv.offsetTop + vv.height));
    if (!(gap > 1)) gap = 0; // sub-pixel noise, and the normal case where the two agree
    if (gap === last) return;
    last = gap;
    if (gap) {
      root.style.setProperty('--wd-vv-bottom', gap + 'px');
      root.style.setProperty('--wd-vv-height', Math.round(vv.height) + 'px');
    } else {
      root.style.removeProperty('--wd-vv-bottom');
      root.style.removeProperty('--wd-vv-height');
    }
  }

  function remeasure() { layoutH = root.clientHeight; sync(); }

  sync();
  vv.addEventListener('resize', remeasure);
  vv.addEventListener('scroll', sync);
  window.addEventListener('resize', remeasure);
  // Orientation change settles a frame or two after the event.
  window.addEventListener('orientationchange', function () { setTimeout(remeasure, 250); });
})();

/* ---------------------------------------------------------------------------------------------
   Product gallery: fit the carousel to the slide being shown.

   The slides have different shapes — a framed preview is a landscape composite while the rest of
   the photos are square — and the track takes the height of the TALLEST one. A shorter slide then
   sits centred in that taller box with an empty band above and below it. Measured on the live
   product page at 390px wide: the framed opening slide is 277px against a 390px track, so 56px of
   empty space above and below.

   slideshow.js already re-sizes the track, but only inside its slide-CHANGE handler, so the
   opening slide never got it. This adds the missing pass without touching that file.

   Two rules make it safe:
     • it always measures the slide that is CURRENTLY showing, never a remembered one. A late lazy
       image must not resize the track to a slide the shopper has already swiped past — that is
       what clipped the square photos in an earlier attempt;
     • it only changes the TRACK's height. The images keep their own size and ratio, so nothing is
       scaled up or cropped.
   --------------------------------------------------------------------------------------------- */
(function () {
  if (window.droolGalleryFitBound) return;
  window.droolGalleryFitBound = true;

  var TRACKS = '.product-information__media slideshow-slides';

  function activeSlide(track) {
    return track.querySelector('slideshow-slide[aria-hidden="false"]')
      || track.querySelector('slideshow-slide');
  }

  function fit(track) {
    if (!track || !track.isConnected) return;
    /* Desktop shows the grid, not the carousel — leave it alone. */
    if (!track.getBoundingClientRect().height && !track.offsetParent) return;
    var slide = activeSlide(track);
    if (!slide) return;

    /* Measure WITHOUT touching `height`. --slide-height feeds the max-height caps (mrk.css), so
       the slide has to be uncapped to read its real height — but clearing the track's `height`
       to do that snapped it to the tallest slide first, and the transition then ran from there,
       which is the jump. Setting the variable to `none` lifts the caps and leaves `height` alone,
       so the change animates from where the track actually is. No paint happens in between: the
       final values are set in the same frame as the measurement. */
    var prevVar = track.style.getPropertyValue('--slide-height');
    track.style.setProperty('--slide-height', 'none');
    var height = slide.offsetHeight;
    if (!height) { /* nothing measurable yet — put back what was there */
      if (prevVar) track.style.setProperty('--slide-height', prevVar);
      else track.style.removeProperty('--slide-height');
      return;
    }
    if (Math.abs(parseFloat(track.style.height) - height) < 1) {
      track.style.setProperty('--slide-height', height + 'px');
      return; /* already the right height — don't restart the transition */
    }

    /* The very first pass sets the starting height, so it must not animate — otherwise the
       gallery visibly resizes on page load. Later changes animate via the CSS transition. */
    var first = !track.dataset.wdFitDone;
    if (first) {
      track.dataset.wdFitDone = '1';
      track.style.transition = 'none';
    }
    track.style.setProperty('--slide-height', height + 'px');
    track.style.height = height + 'px';
    if (first) {
      void track.offsetHeight; /* commit the height before transitions come back */
      track.style.transition = '';
    }
  }

  var queued = false;
  function fitAll() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      var tracks = document.querySelectorAll(TRACKS);
      for (var i = 0; i < tracks.length; i++) fit(tracks[i]);
    });
  }

  function bind(track) {
    if (track.dataset.wdFitBound) return;
    track.dataset.wdFitBound = '1';
    /* The active slide is marked with aria-hidden, so that attribute is the slide-change signal. */
    if (typeof MutationObserver !== 'undefined') {
      new MutationObserver(fitAll).observe(track, {
        attributes: true, attributeFilter: ['aria-hidden'], subtree: true,
      });
    }
    /* Images arrive late (lazy frames, mock-ups). `load` does not bubble, so capture it.
       fitAll re-reads the ACTIVE slide, so a late image can never resize the track to another. */
    track.addEventListener('load', fitAll, true);
    fitAll();
  }

  function scan() {
    var tracks = document.querySelectorAll(TRACKS);
    for (var i = 0; i < tracks.length; i++) bind(tracks[i]);
  }

  scan();
  document.addEventListener('DOMContentLoaded', scan);
  window.addEventListener('load', function () { scan(); fitAll(); });
  window.addEventListener('resize', fitAll);
  window.addEventListener('orientationchange', function () { setTimeout(fitAll, 250); });
})();

/* Cart drawer recommendation cards: picking a size in the custom size dropdown.
   This used to be an inline <script> inside snippets/custom-recs-product.liquid, but that markup
   only ever reaches the page through innerHTML (the ?view=upsell fetch) or a Section Rendering
   morph, and scripts inserted either way never execute. So for shoppers the handler was never
   bound: the dropdown opened (popovertarget needs no script) but tapping a size did nothing, and
   Add then put the DEFAULT size in the cart. It only ever worked in the theme editor, where the
   snippet is rendered inline. Every listener here is delegated on document and bound once, so it
   belongs in a file that loads on every page. Moved unchanged. */
(function () {
  // Drives the custom size dropdown on the recommendation cards. All three listeners are
  // delegated on `document` and bound once, because this markup is re-rendered by the Section
  // Rendering API and morphed back into the drawer on every cart change — anything bound to the
  // cards themselves would be lost, and any state written onto them would be overwritten.
  if (window.__wdRecSizeSelectBound) return;
  window.__wdRecSizeSelectBound = true;

  var MENU = '.wd-rec-size-menu';
  var OPTION = '.wd-rec-size-option';

  function optionsIn(menu) {
    return Array.prototype.slice.call(menu.querySelectorAll(OPTION)).filter(function (option) {
      return !option.disabled;
    });
  }

  // `beforetoggle` does not bubble, so listen in the CAPTURE phase — capture reaches the target
  // for non-bubbling events too. Runs before the popover is painted, which is where the size and
  // direction have to be settled or the panel opens in the wrong place for one frame.
  document.addEventListener(
    'beforetoggle',
    function (event) {
      var menu = event.target;
      if (!menu || !menu.classList || !menu.classList.contains('wd-rec-size-menu')) return;
      if (event.newState !== 'open') return;

      var wrapper = menu.closest('.wd-rec-size-select-wrapper');
      var trigger = wrapper && wrapper.querySelector('.wd-rec-size-trigger');
      if (!trigger) return;

      // anchored-popover-component publishes the trigger's viewport edges as --anchor-*. It does
      // not publish the trigger's own size, and the CSS needs it to sit the panel directly above
      // or below the pill. Taking it here avoids deriving it from 100vh, which does not match
      // window.innerHeight on mobile Safari while the URL bar is collapsing.
      var rect = trigger.getBoundingClientRect();
      menu.style.setProperty('--wd-anchor-w', rect.width + 'px');
      menu.style.setProperty('--wd-anchor-h', rect.height + 'px');

      // The panel is display:none until it opens, so its height cannot be measured yet. Estimate
      // it from the row count against the same 240px cap the CSS applies, and open upwards when
      // there is more room above — the recommendation strip often sits low in the drawer.
      var rows = menu.querySelectorAll(OPTION).length;
      var wanted = Math.min(240, rows * 30 + 8);
      var below = window.innerHeight - rect.bottom - 8;
      var above = rect.top - 8;
      menu.classList.toggle('wd-rec-size-menu--up', below < wanted && above > below);
    },
    true
  );

  // Move focus to the chosen size once the panel is actually open, so the keyboard lands inside
  // the list rather than after the trigger. `toggle` does not bubble either.
  document.addEventListener(
    'toggle',
    function (event) {
      var menu = event.target;
      if (!menu || !menu.classList || !menu.classList.contains('wd-rec-size-menu')) return;
      if (event.newState !== 'open') return;
      var selected = menu.querySelector(OPTION + '[aria-selected="true"]:not([disabled])');
      (selected || optionsIn(menu)[0] || menu).focus();
    },
    true
  );

  document.addEventListener('click', function (event) {
    var option = event.target.closest(OPTION);
    if (!option || option.disabled) return;

    var menu = option.closest(MENU);
    var card = option.closest('.wd-rec-card');
    if (!menu || !card) return;

    var variantId = option.getAttribute('data-variant-id');

    var variantInput = card.querySelector('input[name="id"]');
    if (variantInput) {
      variantInput.value = variantId;
      variantInput.disabled = false;
    }

    // The partner codes follow the size. Each option carries its variant's codes as JSON
    // (snippets/drool-fulfilment-values.liquid); copy them into the form's hidden inputs.
    // A missing code is flagged in _fulfilment_check rather than sent blank (as mrk.js does).
    var wdFd = null;
    try { wdFd = JSON.parse(option.getAttribute('data-wd-fulfilment') || 'null'); } catch (e) { wdFd = null; }
    if (wdFd && card.querySelector('input[data-wd-prop]')) {
      var wdMissing = [];
      var wdCodes = { _prodigi_sku: wdFd.p || '', _alf_sku: wdFd.a || '' };
      Object.keys(wdCodes).forEach(function (k) {
        var input = card.querySelector('input[data-wd-prop="' + k + '"]');
        if (!input) return;
        input.value = wdCodes[k];
        input.disabled = !wdCodes[k];
        if (!wdCodes[k]) wdMissing.push(k);
      });
      var wdCheck = card.querySelector('input[data-wd-prop="_fulfilment_check"]');
      if (wdCheck) {
        wdCheck.value = wdMissing.length ? 'missing:' + wdMissing.join(',') : '';
        wdCheck.disabled = !wdMissing.length;
      }
      var wdRowType = card.querySelector('input[data-wd-prop="_row_type"]');
      if (wdRowType) wdRowType.value = option.getAttribute('data-wd-row-type') || 'print';
    }

    var addButton = card.querySelector('.wd-rec-add-btn');
    if (addButton) addButton.disabled = false;

    var label = card.querySelector('.wd-rec-size-display__label');
    if (label) label.textContent = option.getAttribute('data-size') || '';

    // Clone the row's own price nodes into the trigger rather than rebuilding the markup from
    // strings. The prices are rendered by Liquid, so they are already converted for the market
    // the shopper is in — and cloning cannot introduce an escaping bug (hard rule R1).
    var target = card.querySelector('.wd-rec-size-display__price');
    var source = option.querySelector('.wd-rec-size-option__price');
    if (target && source) {
      target.replaceChildren.apply(target, Array.prototype.map.call(source.childNodes, function (node) {
        return node.cloneNode(true);
      }));
    }

    var all = menu.querySelectorAll(OPTION);
    for (var i = 0; i < all.length; i++) {
      all[i].setAttribute('aria-selected', all[i] === option ? 'true' : 'false');
    }

    if (menu.hidePopover && menu.matches(':popover-open')) menu.hidePopover();
  });

  // Arrow keys move through the list. Escape and click-outside are handled by popover="auto".
  document.addEventListener('keydown', function (event) {
    var menu = event.target.closest && event.target.closest(MENU);
    if (!menu) return;

    var keys = { ArrowDown: 1, ArrowUp: -1, Home: 0, End: 0 };
    if (!(event.key in keys)) return;

    var options = optionsIn(menu);
    if (!options.length) return;

    var index = options.indexOf(event.target.closest(OPTION));
    var next;
    if (event.key === 'Home') next = 0;
    else if (event.key === 'End') next = options.length - 1;
    else next = Math.min(options.length - 1, Math.max(0, index + keys[event.key]));

    event.preventDefault();
    options[next].focus();
  });
})();
